var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(this.configurationMenu.page)?_c('TemplateConfigurationItemPage',{attrs:{"page":this.configurationMenu.page,"title":this.configurationMenu.name}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }